
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.507 11.679c-.5-.546-1.278-1.283-1.609.38-.112.567-.375 1.003-.6 1.354-.243-1.229-.973-2.5-1.662-3.358-.257-.32-1.171-1.596-1.346-3.73a.384.384 0 00-.641-.253c-2.261 2.053-3.502 4.875-3.548 8.053 0 0-.942-.793-1.453-2.27-.138-.397-.67-.473-.902-.122a3.544 3.544 0 00-.123.201C7.88 15.02 7.04 18.764 7.815 22.25c1.297 5.835 9.877 7.467 14.42 3.799 4.443-3.588 3.03-10.268-.728-14.37z","fill":"#ED694A"}}),_c('path',{attrs:{"d":"M20.136 15.944c-.37-.403-.944-.948-1.188.281-.083.418-.277.74-.444 1-.18-.908-.719-1.847-1.227-2.48-.19-.237-.865-1.18-.995-2.755a.283.283 0 00-.473-.187c-1.67 1.516-2.587 3.6-2.62 5.948 0 0-.696-.586-1.074-1.677-.101-.293-.495-.35-.666-.09-.033.05-.063.1-.09.149-1.289 2.278-1.909 5.044-1.336 7.618.958 4.31 7.295 5.515 10.65 2.806 3.282-2.65 2.24-7.583-.537-10.613z","fill":"#F4A32C"}}),_c('path',{attrs:{"d":"M18.883 19.839c-.25-.273-.639-.642-.804.19a1.928 1.928 0 01-.3.677c-.122-.614-.487-1.25-.83-1.679-.13-.16-.587-.798-.674-1.865a.192.192 0 00-.32-.126c-1.131 1.026-1.752 2.437-1.775 4.026 0 0-.47-.397-.726-1.135-.069-.198-.336-.236-.451-.06a1.773 1.773 0 00-.062.1c-.872 1.542-1.291 3.415-.903 5.157.648 2.918 4.938 3.734 7.209 1.9a3.653 3.653 0 001.358-2.492c.147-1.483-.423-3.276-1.722-4.693z","fill":"#F4D44E"}}),_c('path',{attrs:{"d":"M12.653 7.19a2.054 2.054 0 000-3.19 2.054 2.054 0 000 3.19zM24.803 13.807a2.054 2.054 0 000-3.19c-.463.377-1.012 2.367 0 3.19zM6.85 14.434a1.48 1.48 0 000-2.298c-.335.271-.73 1.706 0 2.299zM19.502 9.488a1.48 1.48 0 000-2.299 1.48 1.48 0 000 2.3z","fill":"#D8553A"}})])
          )
        }
      }
    